import React from "react";

export default function AvisoPrivacidad() {
  return (
    <section id="aviso-privacidad" className="container ptb-100">
      <div className="row">
        <div className="col-lg-10 offset-lg-1">
          <div className="section-heading mb-4">
            <h2>Aviso de Privacidad</h2>
            <p className="lead">
              Última actualización: 23 de agosto de 2025
            </p>
          </div>

          <p>
            En <strong>Selektiando</strong>, nos comprometemos a proteger tus
            datos personales y garantizar tu privacidad. Este aviso explica cómo
            recopilamos, usamos y protegemos tu información cuando utilizas
            nuestros servicios.
          </p>

          <h5 className="mt-4">1. Responsable del tratamiento</h5>
          <p>
            Selektiando, empresa especializada en reclutamiento, selección de
            personal y headhunting con inteligencia artificial, con domicilio
            web en{" "}
            <a href="https://www.selektiando.com">www.selektiando.com</a>, es la
            responsable del tratamiento de tus datos personales.
            Puedes contactarnos a través de nuestras redes sociales oficiales:
          </p>
          <ul>
            <li>
              Instagram:{" "}
              <a href="https://www.instagram.com/selektiando">@selektiando</a>
            </li>
            <li>
              Facebook:{" "}
              <a href="https://www.facebook.com/selektiando">@selektiando</a>
            </li>
            <li>
              WhatsApp:{" "}
              <a href="https://wa.me/528185262144">+52 818 526 2144</a>
            </li>
          </ul>

          <h5 className="mt-4">2. Datos que recopilamos</h5>
          <p>
            Podemos recopilar la siguiente información: nombre completo, correo
            electrónico, número telefónico, experiencia laboral, currículum,
            perfil profesional y datos de navegación o interacción digital.
          </p>

          <h5 className="mt-4">3. Finalidad del tratamiento</h5>
          <p>
            Los datos personales se utilizan para ofrecer servicios de
            reclutamiento, filtrar candidatos, enviarte vacantes adecuadas,
            automatizar entrevistas mediante IA, brindar atención personalizada
            y generar métricas internas.
          </p>

          <h5 className="mt-4">4. Transferencia de datos</h5>
          <p>
            No vendemos tus datos. Solo compartimos información con empresas
            clientes cuando tú lo autorizas expresamente, como parte del proceso
            de postulación a una vacante.
          </p>

          <h5 className="mt-4">5. Seguridad</h5>
          <p>
            Aplicamos medidas técnicas y organizativas para proteger tu
            información frente a accesos no autorizados, pérdidas o usos
            indebidos. Cumplimos con la Ley Federal de Protección de Datos
            Personales en Posesión de los Particulares (México).
          </p>

          <h5 className="mt-4">6. Derechos ARCO</h5>
          <p>
            Puedes ejercer tus derechos de acceso, rectificación, cancelación u
            oposición al uso de tus datos enviando un correo a:{" "}
            <a href="mailto:privacidad@selektiando.com">
              privacidad@selektiando.com
            </a>
            . Incluye tu nombre completo, medio de contacto y el derecho que
            deseas ejercer.
          </p>

          <h5 className="mt-4">7. Uso de redes sociales y WhatsApp</h5>
          <p>
            Al comunicarte con nosotros vía WhatsApp, Instagram o Facebook,
            aceptas que podamos enviarte información sobre vacantes, procesos o
            servicios. No compartiremos tu información sin tu autorización.
          </p>

          <h5 className="mt-4">8. Cambios a este aviso</h5>
          <p>
            Este aviso puede modificarse en cualquier momento. Te recomendamos
            revisar periódicamente esta sección para conocer la versión más
            actualizada. La política vigente estará siempre publicada en nuestro
            sitio web.
          </p>

          <p className="mt-4">
            Si tienes preguntas sobre este aviso, puedes escribirnos vía WhatsApp
            al{" "}
            <a href="https://wa.me/528185262144">+52 818 526 2144</a> o visitar{" "}
            <a href="https://www.selektiando.com">www.selektiando.com</a>.
          </p>
        </div>
      </div>
    </section>
  );
}
